import React, { useEffect } from 'react';
import { Card, Title, Text, Container, Button, Group, Image } from '@mantine/core';
import { IconLogin } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useOktaAuth } from '../../providers/okta-auth-provider';

export function Login() {
  const { isAuthenticated, isLoading, login, userInfo } = useOktaAuth();
  const navigate = useNavigate();
  

  useEffect(() => {
    
    // Se abbiamo userInfo, significa che l'autenticazione è completa e i dati utente sono caricati
    if (userInfo) {
      const originalUri = sessionStorage.getItem('originalUri') || '/';
      sessionStorage.removeItem('originalUri');
      
      navigate({ to: originalUri });
      
      // Fallback con window.location se navigate non funziona
      setTimeout(() => {
        if (window.location.pathname === '/login') {
          console.warn('Navigation did not work, using window.location fallback');
          window.location.href = originalUri;
        }
      }, 100);
    }
  }, [userInfo, navigate]);
  
  const handleLogin = async () => {
    await login();
  };
  
  return (
    <Container size="xs" py="xl">
      <Card shadow="md" padding="lg" radius="md" withBorder>
        <Card.Section p="md" style={{ textAlign: 'center' }}>
          <div aria-hidden={false} style={{ display: 'flex', justifyContent: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 556 326.2" xmlSpace="preserve" width={160} height={80} role="img" aria-label="Logo">
              <path d="M195.6,117.1c-1.7-1.8-2.8-3.7-2.8-6.7V32.4l84.4,91.5V13.8c0-3,1.1-4.9,2.8-6.7c1.9-2,4.6-4,4.6-4h-27.8c0,0,2.7,2,4.6,4
	c1.7,1.8,2.8,3.7,2.8,6.7v78.1L179.8,0v110.4c0,3-1.1,5-2.8,6.7c-1.9,2-4.6,4-4.6,4h27.8C200.2,121.2,197.5,119.1,195.6,117.1"></path>
              <path d="M156.1,262.4c-1.7-1.8-2.8-3.7-2.8-6.7V148.4h-22.5c0,0,4.9,4.1,6.9,6.7c2.1,2.8,2.6,5.9,2.6,9.9c0,0.5,0,90.8,0,90.8
	c0,3-1.1,5-2.8,6.7c-1.9,2-4.6,4-4.6,4h27.8C160.7,266.4,158,264.4,156.1,262.4"></path>
              <path d="M70.1,81.3c0,0,2-1.8,5.1-3.6c3.9-2.2,7.5-2.8,11.5-2.8h17.8c-3.5,21.8-19.5,36.9-43.3,36.9c-24.6,0-47.4-20-47.4-49.2
	c0-27.7,19.1-49.7,47.6-49.8c9.5,0,17.6,2.6,24.4,7c11,7.1,14.3,17.8,14.3,17.8l12.1-8.6c-1.9-3.1-6.2-9.1-9.9-12.7
	C91,5.7,77.4,0.5,61.4,0.5c-37,0-61.4,29-61.4,62c0,33.4,25.7,61.7,61.1,61.7c35.7,0,57.6-25.8,58.6-61.4H70L70.1,81.3L70.1,81.3
	L70.1,81.3z"></path>
              <path d="M359.3,124.2c36,0,60.8-28.7,60.8-61.9c0-33-24.7-61.9-60.8-61.9s-60.8,28.8-60.8,61.9C298.5,95.5,323.3,124.2,359.3,124.2
	 M359.3,13c27.1,0,47,21.9,47,49.3c0,27.4-19.9,49.5-47,49.5c-27.1,0-47-22.1-47-49.5S332.2,13,359.3,13"></path>
              <path d="M135.4,117.1c-1.9,2-4.6,4-4.6,4h27.8c0,0-2.7-2-4.6-4c-1.7-1.8-2.8-3.7-2.8-6.7V13.8c0-3,1.1-4.9,2.8-6.7
	c1.9-2,4.6-4,4.6-4h-27.8c0,0,2.7,2,4.6,4c1.7,1.8,2.8,3.7,2.8,6.7v96.6C138.2,113.5,137.1,115.4,135.4,117.1"></path>
              <path d="M319.8,203.9c10.4-4.6,17.3-14.7,17.3-26.5c0-18.3-14.6-32.1-34.8-31.8c-20.9,0.3-34,15.2-34.6,32.3l13.7,2.1
	c0,0-0.1-5.8,1.6-10.1c2.2-6.5,9.9-12.1,19.7-12.1c12.5,0,21.5,8.5,21.5,20c0,14.2-11.6,20.5-25.6,21v11.8
	c18.3,0.3,28.5,9.3,28.5,22.8c0,14.7-11.5,23.7-24.5,23.7c-10.5,0-19.2-5.4-22.8-13.3c-1.9-4.4-2.4-6.7-3.1-9.9l-13.5,4
	c4.3,21.1,21,30.9,38.8,30.9c21.8,0,38.1-14.7,38.1-35.3C340.1,219.4,331.8,208.7,319.8,203.9"></path>
              <path d="M179.8,166.9c0,0,2.2-2.4,5.5-4.2c3.1-1.6,5.4-2,9-2h44l-55.5,101.1l14.9,8.8c0,0-0.5-3.3-0.2-6.9c0.3-2.9,0.9-4.4,1.8-6.3
	c0.5-1.1,1.8-3.6,1.8-3.6l58-105.5h-79.3V166.9z"></path>
              <path d="M551.4,117.1c-1.7-1.8-2.8-3.7-2.8-6.7V13.8c0-3,1.1-4.9,2.8-6.7c1.9-2,4.6-4,4.6-4h-27.8c0,0,2.7,2,4.6,4
	c1.7,1.8,2.8,3.7,2.8,6.7v96.6c0,3-1.1,5-2.8,6.7c-1.9,2-4.6,4-4.6,4H556C556,121.2,553.3,119.1,551.4,117.1"></path>
              <path d="M510.3,110.7l-27.8-42.4c17.3-3.2,26.8-14.8,26.8-32.4c0-12.6-6-21.6-12.8-26.2c-8.8-6-20.5-6.6-28.5-6.6l-34.2,0
	c0,0,2.7,2,4.6,4c1.7,1.8,2.8,3.7,2.8,6.7v96.6c0,3-1.1,5-2.8,6.7c-1.9,2-4.6,4-4.6,4h27.8c0,0-2.7-2-4.6-4
	c-1.7-1.8-2.8-3.7-2.8-6.7V69.5h14l33.4,51.7h21.7C523.3,121.2,515.9,119.3,510.3,110.7 M454.1,57.8V15.5h15.9
	c5.6,0,11.6,0.4,16.9,3.4c7.4,4.2,9.2,10.8,9.2,17.4c0,13.8-9.5,21.6-25.7,21.6H454.1z"></path>
              <path d="M389,189.5c-4.1,0.1-8.5,0.7-12.6,1.7l5.1-30.5l40.6,0.1v-17.5c0,0-2.6,2-5.9,3.5c-2.6,1.1-4.3,1.4-6.4,1.5
	c-0.6,0-1.5,0.1-2.5,0.1h-35.7l-10.3,60.5c5.4-3.5,13.8-7.5,24.1-7.8c18.1-0.5,29.8,10.1,30.4,27.4c0.5,16.4-11.8,29.4-27.9,28.5
	c-7-0.4-13.8-2.4-19.1-6.7c-3.3-2.7-6.9-6.4-8.8-9.6l-10.6,8.9c10.1,13.1,26,19.3,39.2,19.3c23.8,0,40.3-17.2,40.3-40.4
	C428.9,206.8,413.6,189,389,189.5"></path>
              <path d="M235.2,311.6h-2c-0.2,0-0.5,0.2-0.5,0.5v13.6c0,0.2,0.2,0.5,0.5,0.5h2c0.2,0,0.5-0.2,0.5-0.5v-13.6
	C235.6,311.8,235.4,311.6,235.2,311.6"></path>
              <path d="M305.8,311.6h-2c-0.2,0-0.5,0.2-0.5,0.5v13.6c0,0.2,0.2,0.5,0.5,0.5h2c0.2,0,0.5-0.2,0.5-0.5v-13.6
	C306.2,311.8,306,311.6,305.8,311.6"></path>
              <path d="M255.8,311.6h-7.6c-0.2,0-0.5,0.2-0.5,0.5v1.8c0,0.2,0.2,0.5,0.5,0.5h2.4v11.4c0,0.2,0.2,0.5,0.5,0.5h2
	c0.2,0,0.5-0.2,0.5-0.5v-11.4h2.4c0.2,0,0.4-0.2,0.4-0.5v-1.8C256.2,311.8,256,311.6,255.8,311.6"></path>
              <path d="M292.4,323.5h-3.6v-11.4c0-0.2-0.2-0.5-0.5-0.5h-2c-0.2,0-0.5,0.2-0.5,0.5v13.6c0,0.2,0.2,0.5,0.5,0.5h2h4
	c0.2,0,0.5-0.2,0.5-0.5v-1.8C292.9,323.6,292.7,323.5,292.4,323.5"></path>
              <path d="M272.5,312.1c0-0.2-0.3-0.4-0.5-0.4h-3.1c-0.2,0-0.5,0.2-0.5,0.4l-3.1,13.6c0,0.2,0.1,0.4,0.3,0.4h1.9
	c0.2,0,0.5-0.2,0.5-0.4l0.4-1.8h4.1l0.4,1.8c0,0.2,0.3,0.4,0.5,0.4h1.9c0.2,0,0.4-0.2,0.3-0.4L272.5,312.1z M268.9,321.6l1.5-7.1
	h0.3l1.5,7.1H268.9z"></path>
              <path d="M326.7,325.7l-3.1-13.7c0-0.2-0.3-0.4-0.5-0.4H320c-0.2,0-0.5,0.2-0.5,0.4l-3.1,13.7c0,0.2,0.1,0.4,0.4,0.4h1.9
	c0.2,0,0.5-0.2,0.5-0.4l0.4-1.8h4.1l0.4,1.8c0,0.2,0.3,0.4,0.5,0.4h1.9C326.6,326.1,326.8,326,326.7,325.7 M321.4,314.5h0.2l1.5,7.1
	H320L321.4,314.5z"></path>
            </svg>
          </div>
        </Card.Section>
        
        <Title order={2} ta="center" mt="md" mb="md">
          Benvenuto
        </Title>
        
        <Text c="dimmed" size="sm" ta="center" mb="xl">
          Accedi con il tuo account aziendale per continuare
        </Text>
        
        <Group justify="center">
          <Button 
            leftSection={<IconLogin size={16} />}
            onClick={handleLogin}
            size="md"
            fullWidth
            loading={isLoading}
          >
            Accedi con SSO
          </Button>
        </Group>
      </Card>
    </Container>
  );
}